<template>
  <v-container
    fluid
    class="fill-height d-flex align-center justify-center text-center"
  >
    <v-row justify="center">
      <v-col cols="12" md="6">
        <!-- Big 404 -->
        <h1 class="display-2 font-weight-bold primary--text mb-4">
          404
        </h1>

        <!-- Title -->
        <h2 class="text-h5 font-weight-medium mb-3">
          Page Not Found
        </h2>

        <!-- Description -->
        <p class="grey--text text--darken-1 mb-6">
          The page you're looking for doesn’t exist or has been moved.
        </p>

        <!-- Action Buttons -->
        <v-btn
          color="primary"
          large
          class="mr-3"
          @click="$router.push({ name: 'Home' })"
        >
          Go Home
        </v-btn>

        <v-btn outlined large @click="$router.back()">
          Go Back
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "NotFound"
};
</script>

<style scoped>
.fill-height {
  min-height: 100vh;
}
</style>
